module.exports = __webpack_public_path__ + "img/8.138c90c3.png";